import Portfolioinfo from "../../../jsx/components/Dashboard/portfolioinfo/portfolioinfo";

const PortfolioInfoWrapper = () => {
  return <Portfolioinfo />;
};

export default constore(PortfolioInfoWrapper);
